var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{style:({
    textDecoration: 'none',
  }),attrs:{"to":{
    path: '/auth/reset-password',
  }}},[_c('v-btn',{staticClass:"text-none px-2 ml-md-n1",attrs:{"text":""}},[_c('span',{staticClass:"text-body-2 primary--text font-weight-bold"},[_vm._v("Forgot password?")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }